




































































































import Vue from "vue";

export default Vue.extend({
  name: "Header",

  data() {
    return {
      language: this.$vuetify.lang.current
    };
  },

  methods: {
    changeToFrench() {
      this.$vuetify.lang.current = "fr";
    },

    changeToEnglish() {
      this.$vuetify.lang.current = "en";
    },

    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }
  }
});
